<div class="chart-container">
  <div class="chart-header">
    <div class="chart-title">
      @if (chartType === 'job1') {
        <span>Model 1</span>
      }
      @if (chartType === 'job2') {
        <span>Model 2</span>
      }
      @if (chartType === 'difference') {
        <span>Difference [{{ comparisonData?.job1?.job_name.substring(0, 6) }}] – [{{ comparisonData?.job2?.job_name.substring(0, 6) }}]</span>
      }
      @if (chartType === 'interleaved') {
        <span>Interleaved</span>
      }
    </div>
    <div class="chart-info">
      <span class="chart-dimension">{{ comparisonData?.dimension || 'Crossline' }}</span>
      @if (!is2d) {
        <span class="chart-slice">Slice: {{ comparisonData?.sliceNumber || 0 }}</span>
      }
      @if (chartType !== 'difference' && chartType !== 'interleaved') {
        <span class="chart-iteration">Iteration: {{ chartType === 'job1' ? comparisonData?.iteration1 : comparisonData?.iteration2 || 0 }}</span>
      }
    </div>
  </div>

  <div class="chart-content" #chart>

    @if (isLoading) {
      <div class="chart-loading" style="display: flex; justify-content: center; align-items: center; height: 100%;">
        <nz-spin nzTip="Loading comparison image..." nzSize="large"></nz-spin>
      </div>
    }


    @if (hasError && !isLoading) {
      <div class="chart-error" style="display: flex; justify-content: center; align-items: center; height: 100%;">
        <nz-result nzStatus="error" [nzTitle]="errorMessage"></nz-result>
      </div>
    }

    <!-- Show message when no data but not in error state -->
    @if (!hasError && !isLoading && !comparisonData) {
      <div class="chart-no-data" style="display: flex; justify-content: center; align-items: center; height: 100%; min-height: 300px;">
        <nz-empty
          nzNotFoundContent="Settings have been changed. Click 'Plot Comparison' to generate new visualization."
          [nzNotFoundImage]="'simple'">
        </nz-empty>
      </div>
    }
  </div>
</div>